<script lang="ts">
	import { onMount } from 'svelte';
	import ArrowUp from 'assets/svg/arrowUp.svg?component';
	import ArrowDown from 'assets/svg/arrowDown.svg?component';
	import type { IVariants } from './types';
	import Active from 'assets/svg/activeCoins.svg?component';
	import Dead from 'assets/svg/deadCoins.svg?component';
	import New from 'assets/svg/newCoins.svg?component';

	export let variants: IVariants[];
	export let dark: boolean = false;
	export let handleClick: (arg1: string | number | object) => void = () => {};
	export let showIcon = false;
	export let minWidth: number;
	export let alignStart = false;
	export let selectedScale = variants[0];
	export let selectObject = false;
	let inputRef;
	let isOpen = false;

	onMount(() => {
		document.addEventListener('click', handleClose);

		return () => {
			document.removeEventListener('click', handleClose);
		};
	});

	const handleClose = (e: Event) => {
		if (inputRef && !inputRef.contains(e.target)) {
			isOpen = false;
		}
	};
</script>

<div class="wrapper" class:dark>
	<div
		bind:this={inputRef}
		class="scale-wrapper"
		style={`min-width: ${minWidth}px; justify-content: ${alignStart ? 'flex-start' : 'flex-end'}`}
		on:click={() => {
			isOpen = !isOpen;
		}}
	>
		<div class="selected-item">
			{#if showIcon && selectedScale.value === 'active'}
				<Active width={12} height={12} class="selected-icon" />
			{/if}
			{#if showIcon && selectedScale.value === 'new'}
				<New width={12} height={12} class="selected-icon" />
			{/if}
			<p class="selected-scale">
				{selectedScale.name}
			</p>
		</div>

		{#if isOpen}
			<ArrowUp class={`select-icon ${dark ? 'dark' : ''}`} width={8} height={8} />
		{:else}
			<ArrowDown class={`select-icon ${dark ? 'dark' : ''}`} width={8} height={8} />
		{/if}
	</div>
	<ul class="variants border-shadow" class:visible={isOpen}>
		{#each variants as variant}
			<li
				class="item"
				on:click={() => {
					selectedScale = variant;
					handleClick(selectObject ? variant : variant.value);
				}}
			>
				{#if variant.icon}
					<div class="icon-wrapper">
						{#if variant.value === 'active'}
							<Active width={12} height={12} class="variant-icon" />
						{/if}
						{#if variant.value === 'new'}
							<New width={12} height={12} class="variant-icon" />
						{/if}
						{#if variant.value === 'dead'}
							<Dead width={12} height={12} class="variant-icon" />
						{/if}
						<p class="text">{variant.name}</p>
					</div>
				{:else}
					{variant.name}
				{/if}
			</li>
		{/each}
	</ul>
</div>

<style lang="scss">
	@import 'tableOptionsFilterSelect';
</style>
